import { useContext } from 'react';

import { useModal } from '@/context/ModalContext';

import { ModalContext } from '../Modal/config';

const useBoostHelp = (): boolean => {
  const {
    isQuarryBoostModalOpen,
    isFactoryBoostModalOpen,
    isGoodsBoostModalOpen,
  } = useModal();
  const { isOpen, modalContent } = useContext(ModalContext);

  return (
    isQuarryBoostModalOpen ||
    isFactoryBoostModalOpen ||
    isGoodsBoostModalOpen ||
    (isOpen && modalContent.renderKind === 'boostFactory')
  );
};

export default useBoostHelp;
